// --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
// MARK: -  Object Definition
export class CodeComponentPropertyDefinition {
    // --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- --- ---
    // MARK: - Constructor
    constructor(model) {
        var _a;
        // this.control = new CodeComponentPropertyControlDefinition(model.control)
        this.defaultValue = (_a = model.defaultValue) !== null && _a !== void 0 ? _a : null;
        this.name = model.name;
        this.required = model.required;
        this.type = model.type;
    }
}
